module.exports = __webpack_public_path__ + "img/Switch-sort.47e08535.svg";